var map = {
	"./carousel-video-00.mp4": 1164,
	"./carousel-video-01.mp4": 3009,
	"./carousel-video-02.mp4": 222,
	"./carousel-video-03.mp4": 7731,
	"./carousel-video-04.mp4": 7528,
	"./carousel-video-05.mp4": 7469,
	"./carousel-video-06.mp4": 7370,
	"./carousel-video-07.mp4": 1855,
	"./carousel-video-08.mp4": 3412,
	"./carousel-video-09.mp4": 8009,
	"./carousel-video-10.mp4": 9843,
	"./carousel-video-11.mp4": 8830,
	"./carousel-video-12.mp4": 9313,
	"./carousel-video-13.mp4": 5356,
	"./carousel-video-14.mp4": 5551,
	"./carousel-video-15.mp4": 6042,
	"./carousel-video-16.mp4": 4685,
	"./carousel-video-17.mp4": 2696,
	"./carousel-video-18.mp4": 5675,
	"./carousel-video-19.mp4": 5254,
	"./carousel-video-20.mp4": 9398,
	"./carousel-video-21.mp4": 7339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 870;